<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reload="reload" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model="form.keyword"
              :placeholder="
                $l('shipmentPlan_label_search') ||
                  '交货批次号/订单编号/客户订单编号/业务人员/跟单人员/下单客户/执行工厂/目的港口 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('batchChoose')"
            >
              {{ $l('form_shipment_batch_verification') || '发运批次校验' }}
            </b-button>
            <b-button
              size="sm"
              variant="outline-success"
              class="ml-2"
              @click="$emit('exportExcel')"
            >
              <i class="el-icon-folder-opened"></i>
              {{ $l('INDEX.btn_export') || '导出' }}
            </b-button>
            <el-badge :value="badgeNumber" class="item">
              <b-button
                size="sm"
                class="ml-2"
                variant="outline-success"
                @click="$emit('confirmShipment')"
              >
                {{ $l('form_confirm_shipment') || '确认发运' }}
              </b-button>
            </el-badge>
          </b-input-group>
        </b-form>
      </b-col>

      <el-dialog
        :title="$l('INDEX.advanced_search') || '高级搜索'"
        :show-close="true"
        :visible.sync="advqueryDialogVisible"
        width="1000px"
        :close-on-click-modal="false"
      >
        <el-form
          ref="form"
          :model="form"
          label-position="right"
          label-width="135px"
          size="small"
        >
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="
                  $l('INDEX.order_form_label_custOrderNo') || '客户订单编号'
                "
              >
                <el-input
                  v-model.trim="form.custOrderNo"
                  clearable
                  size="small"
                >
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.order_form_label_orderNo') || '订单编号'"
              >
                <el-input v-model.trim="form.orderNo" clearable size="small">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="
                  $l('INDEX.order_form_batch_label_identifyNo') ||
                    '批次识别单号'
                "
              >
                <el-input v-model.trim="form.identifyNo" clearable size="small">
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item
                :label="
                  $l('INDEX.order_form_label_salesPersonCode') || '业务人员'
                "
              >
                <dict-select
                  clearable
                  v-model="form.salesPersonCode"
                  filterable
                  size="small"
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="
                    $l('INDEX.form_label_please_select_a_business_person') ||
                      '请选择业务人员'
                  "
                  :selectedLabel.sync="form.salesPersonName"
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="
                  $l('INDEX.order_form_label_bizPersonCode') || '跟单人员'
                "
              >
                <dict-select
                  clearable
                  v-model="form.bizPersonCode"
                  filterable
                  size="small"
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="
                    $l('INDEX.form_label_please_select_a_business_person') ||
                      '请选择业务人员'
                  "
                  :selectedLabel.sync="form.bizPersonName"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                size="small"
                :label="$l('INDEX.order_form_label_custCode') || '下单客户'"
              >
                <dict-select
                  clearable
                  v-model="form.custCode"
                  filterable
                  url="/master/common/dict/customerSelect"
                  style="width:100%"
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                size="small"
                :label="$l('INDEX.order_form_label_endCustCode') || '终端客户'"
              >
                <dict-select
                  clearable
                  v-model="form.endCustCode"
                  filterable
                  url="/master/common/dict/customerSelect"
                  style="width:100%"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.order_form_label_scmCode') || '执行工厂'"
              >
                <dict-select
                  size="small"
                  clearable
                  filterable
                  v-model="form.scmCode"
                  :body="{}"
                  url="/master/common/dict/scmPartners"
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.order_form_label_orderScmCode') || '名义工厂'"
              >
                <dict-select
                  size="small"
                  clearable
                  filterable
                  v-model="form.orderScmCode"
                  :body="{}"
                  url="/master/common/dict/scmPartners"
                ></dict-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-row>
                <el-form-item
                  :label="$l('INDEX.form_label_cargoReadyDay') || '货好时间'"
                >
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.beginCargoReadyDay"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :picker-options="beginCargoReadyDayPicker"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.endCargoReadyDay"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :picker-options="endCargoReadyDayPicker"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-row>
                <el-form-item
                  :label="
                    $l('INDEX.order_form_batch_label_shipmentStartDate') ||
                      '客户交期'
                  "
                >
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.beginShipmentDate"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :picker-options="beginShipmentDatePicker"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.endShipmentDate"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :picker-options="endShipmentDatePicker"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row>
                <el-form-item
                  :label="
                    $l('INDEX.order_form_batch_label_shipmentEndDate') ||
                      '客户交期'
                  "
                >
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.beginShipmentEndDate"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :picker-options="beginShipmentEndDatePicker"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.endShipmentEndDate"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :picker-options="endShipmentEndDatePicker"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="closeAdvqueryDialog">{{
            $l('INDEX.btn_cancel_query') || '取消查询'
          }}</el-button>
          <el-button size="small" type="warning" @click="reload">{{
            $l('INDEX.btn_reset_filter') || '重置条件'
          }}</el-button>
          <el-button size="small" type="primary" @click="advquery">{{
            $l('INDEX.btn_data_retrieval') || '数据检索'
          }}</el-button>
        </span>
      </el-dialog>
    </b-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
const initForm = { keyword: '', bizPersonCode: '' }
export default {
  props: {
    disabled: { type: Boolean, default: false },
    badgeNumber: { type: Number, default: 0 },
  },
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      deliveryTypeParams: { dictType: 'deliveryType' },
      outBillTypeParams: { dictType: 'outBillType' },
      beginShipmentDatePicker: this.endShipmentDate(),
      endShipmentDatePicker: this.beginShipmentDate(),
      beginShipmentEndDatePicker: this.endShipmentEndDate(),
      endShipmentEndDatePicker: this.beginShipmentEndDate(),
      beginCargoReadyDayPicker: this.endCargoReadyDay(),
      endCargoReadyDayPicker: this.beginCargoReadyDay(),
    }
  },
  computed: {
    ...mapState('admin/user', ['info']),
  },
  watch: {
    info: {
      handler(userInfo) {
        const { userCode } = userInfo || {}
        this.form.bizPersonCode = userCode || ''
        this.query()
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    //初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    //高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    //重置条件查询
    reload() {
      this.form = { ...initForm }
      const { userCode } = this.info || {}
      this.form.bizPersonCode = userCode || ''
    },
    //打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    //关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    endShipmentDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.endShipmentDate) {
            //如果结束时间不为空，则小于结束时间
            return (
              new Date(self.form.endShipmentDate).getTime() < time.getTime()
            )
          }
        },
      }
    },
    beginShipmentDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.beginShipmentDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.beginShipmentDate).getTime() -
                3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    endShipmentEndDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.endShipmentEndDate) {
            //如果结束时间不为空，则小于结束时间
            return (
              new Date(self.form.endShipmentEndDate).getTime() < time.getTime()
            )
          }
        },
      }
    },
    beginShipmentEndDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.beginShipmentEndDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.beginShipmentEndDate).getTime() -
                3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },

    beginCargoReadyDay() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.beginCargoReadyDay) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.beginCargoReadyDay).getTime() -
                3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    endCargoReadyDay() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.endCargoReadyDay) {
            //如果结束时间不为空，则小于结束时间
            return (
              new Date(self.form.endCargoReadyDay).getTime() < time.getTime()
            )
          }
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
